module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "log-content"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('h3', [_c('translate', [_vm._v("Viewing Of Log Content")])], 1), _vm._v(" "), _c('div', [_c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.logContent),
      expression: "logContent",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.downLoad()
      }
    }
  }, [_c('translate', [_vm._v("Download")])], 1)], 1)]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.logContent))]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "日志解冻",
      "visible": _vm.freezeShow,
      "top": "20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.freezeShow = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pollingLoading),
      expression: "pollingLoading"
    }],
    staticClass: "dialog-content",
    attrs: {
      "element-loading-text": "日志正在解冻中，请稍等..."
    }
  }, [(_vm.pollingCode == 'OSSFileAvailable') ? _c('p', {
    staticClass: "text"
  }, [_vm._v("解冻完成，文件正在下载...")]) : _c('p', {
    staticClass: "text"
  }, [_vm._v("检测到您所选择的日志文件目前处于\"冷冻\"归档状态，如您需要继续\"下载\"，请点击\"确认\"发起解冻请求。日志文件\"解冻\"通常需要5-10分钟左右，请耐心等待。")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pollingLoading,
      "link": ""
    },
    on: {
      "click": function($event) {
        _vm.freezeShow = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.pollingLoading || _vm.pollingCode == 'OSSFileArchived') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pollingLoading
    },
    on: {
      "click": _vm.handleFreezeConfirm
    }
  }, [_vm._v("确认")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-882b8204"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/excel-log-view.vue
// module id = 599
// module chunks = 4 5 6